import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Ensure the eventId route parameter is a valid number
export const eventIdGuard: CanActivateFn = (route) => {
  const router = inject(Router);  
  const blockId = route.paramMap.get('blockId');
  const idString = route.paramMap.get('eventId');

  // Reject null/empty/whitespace values
  if (idString === null || idString.trim() === '') {
    return router.createUrlTree(['/tracking/blocks', blockId]);
  }

  const id = Number(idString);

  // If the eventId parameter is not a valid number, redirect back to block page
  if (Number.isNaN(id) || !Number.isInteger(id) || id < 0) {
    return router.createUrlTree([`/tracking/blocks/`, blockId]); 
  }

  return true;
};
